import { render, staticRenderFns } from "./list-area.vue?vue&type=template&id=5fd700b8&"
import script from "./list-area.vue?vue&type=script&lang=js&"
export * from "./list-area.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "list-area.vue"
export default component.exports